/*
 * @Descripttion: 首页
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-07-21 11:32:51
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2023-12-20 17:18:59
 */
const frontPage = {
  banner: {
    banner1: {
      title: ['Bringing precision to medicine'],
      des: ['']
    },
    banner2: {
      title: ['Pioneering the era of FFR testing without guide pressure wires'],
      des: ['']
    },
    banner3: {
      title: ['Experts in the field of cardiovascular and cerebrovascular diseases'],
      des: ['']
    }
  },
  introduction: {
    title: 'ArteryFlow Technology',
    des: 'Bringing precision to medicine',
    banner: [
      {
        id: 1,
        title: 'Company',
        des: ['ArteryFlow Technology is an innovative company based on medical big data, computational simulation and AI algorithms to provide precise and personalized diagnosis and treatment for cardiovascular and cerebrovascular diseases, with profound technical accumulations in computational simulation, AI, and medical imaging analysis. The core team members are experts in both technology and clinical practice.']
      }, {
        id: 2,
        title: 'Team',
        des: ['ArteryFlow Technology has assembled a world-class team of cross-disciplinary experts in computational simulation, AI, and medical imaging analysis. The founding team members have world-class research experience in the field of cardiovascular and cerebrovascular diseases for over 20 years with hundreds of publications and 103 applied patents. The core R&D team members are from top universities such as MIT and Imperial College London, with profound technical accumulations in computational simulation, AI, and medical imaging analysis.']
      }, {
        id: 3,
        title: 'Expertise',
        des: ["ArteryFlow Technology has abundant domestic and international medical resources. We have deep collaborations with the world's leading interventional center, the Buffalo GVI Center in the United States.  We have accumulated decades of experience working closely with clinical doctors domestically and internationally and have established deep clinical collaborations with hundreds of hospitals worldwide. Over 70% members in ArteryFlow Technology have extensive experience in clinical medical practice and scientific research, and the R&D and marketing of large medical products."]
      }, {
        id: 4,
        title: 'Data',
        des: ['Based profound accumulations in deep learning, hemodynamics, imaging analysis and other fields, ArteryFlow Technology has accumulated a large amount of clinical and imaging data through in-depth cooperation with hundreds of hospitals, ensuring the training and validation of deep learning models.']
      }
    ],
    related: {
      hospitals: 'Collaborative Hospitals',
      province: 'Covered Provinces',
      second: 'Hemodynamic Analysis',
      percentage: 'AccuFFRangio Accuracy'
    },
    more: 'More'
  },
  partner: {
    title: 'Partners',
    des: 'ArteryFlow collaborates closely with hundreds of institutions',
    type: ['Neurology', 'Cardiology'],
    skull: {
      title: 'Cooperative hospitals in neurointervention',
      des: ''
    },
    heart: {
      title: 'Cooperative hospitals in cardiology',
      des: ''
    }
  },
  hexinchanping: {
    title: 'Core Products',
    des: ['ArteryFlow Technology has launched three coronary functional assessment systems,', 'and provides a complete solution for cardiovascular and cerebrovascular disease.'],
    innovative: {
      skull: {
        title: 'Cerebrovascular Product Portfolio',
        img: require('@/assets/images/index/hxcp/skull.png'),
        more: 'intracranial',
        list: [
          {
            title: 'AneuFlow',
            des: 'Provides  multidimensional evaluation of intracranial aneurysms.',
            path: '/en/innovative/intracranial/aneuflow'
          }, {
            title: 'AneuGuide',
            des: 'Assists introperative real-time planning for precise intracranial aneurysm interventions.',
            path: '/en/innovative/intracranial/aneuguide'
          }, {
            title: 'AccuCTP',
            des: 'Acquires precious treatment time by rapid and accurate cerebral perfusion analysis.',
            path: '/en/innovative/intracranial/accuctp'
          }, {
            title: 'AccuICAS',
            des: 'Accurately assesses the functional degree of ICAS to prevent most stroke.',
            path: '/en/innovative/intracranial/accuicas'
          }
        ]
      },
      heart: {
        title: 'Cardiovascular Product Portfolio',
        img: require('@/assets/images/index/hxcp/heart.png'),
        more: 'intracardiac',
        list: [
          {
            title: 'AccuFFRct',
            des: 'Performs coronary functional assessment with CTA images  in a non-invasive way.',
            path: '/en/innovative/intracardiac/accuffrct'
          }, {
            title: 'AccuFFRangio',
            des: 'Provides functional assessment of myocardial ischemia using coronary angiography instead of guidewires.',
            path: '/en/innovative/intracardiac/accuffrangio'
          }, {
            title: 'AccuIMR',
            des: 'Diagnoses the myocardial ischemia from the microcirculation perspective.',
            path: '/en/innovative/intracardiac/accuimr'
          }
        ]
      },
      more: 'More >>',
      img_circle: require('@/assets/images/index/hxcp/en/circle.png'),
      circle_list: [
        {
          title: 'Screening',
          img: require('@/assets/images/index/hxcp/icon1.png')
        }, {
          title: 'Treatment',
          img: require('@/assets/images/index/hxcp/icon2.png')
        }, {
          title: 'Diagnosis',
          img: require('@/assets/images/index/hxcp/icon3.png')
        }
      ],
      t_list: [
        require('@/assets/images/pc/index/hxcp/t_1.png'),
        require('@/assets/images/pc/index/hxcp/t_2.png'),
        require('@/assets/images/pc/index/hxcp/t_3.png'),
        require('@/assets/images/pc/index/hxcp/t_4.png')
      ],
      b_list: [
        require('@/assets/images/pc/index/hxcp/b_1.png'),
        require('@/assets/images/pc/index/hxcp/b_2.png'),
        require('@/assets/images/pc/index/hxcp/b_3.png'),
        require('@/assets/images/pc/index/hxcp/b_4.png')
      ],
      m_b_img: require('@/assets/images/m/index/hxcp/en/bottom.png')
    }
  }
}
export default frontPage
